<template>
  <aha-modal
    title=""
    @hide="$emit('hide')"
  >
    <div class="gift">
      <img src="@/assets/images/icon/gift-box.png" alt="" width="112px">
      <h2 class="mb-4">
        {{ $i18nPresenter.t('Here’s a gift') }}
        <span v-if="currentUser.referralFullName"> from {{ currentUser.referralFullName }}</span>!
      </h2>
      <p>
        {{ $i18nPresenter.t('You got a free One-time (Small) plan because your friend') }}
        {{ currentUser.referralFullName }} {{ $i18nPresenter.t('referred you to AhaSlides.') }}
        <br>
        <br>
        {{
          $i18nPresenter
            .t("This plan allows you to host an event for up to 30 participants with all features unlocked!")
        }}
      </p>
    </div>
    <template #action>
      <div class="w-full">
        <a @click="goToReferral()" class="text-base-80 cursor-pointer underline">
          {{ $i18nPresenter.t("How does it work?") }}
        </a>
      </div>
      <aha-button @click="$emit('hide')" class="w-24">
        <span class="font-bold">{{ $i18nPresenter.t("Got it!") }}</span>
      </aha-button>
    </template>
  </aha-modal>
</template>
<script>
import { mapState } from 'vuex'
import config from '@/config'
import Utils from '@/util'

export default {
  name: 'ReferralCodeModal',
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    referralLink() {
      return `${config.presenterDomain}/pages/register?referral-code=${this.currentUser.referralCode}`
    },
  },
  methods: {
    goToReferral() {
      this.$emit('hide')
      Utils.mixpanelTracking(
        'Presenter Referral Program',
        'Presenter Referral Program > Click how does it work link',
        'Click how does it work link',
      )
      window.open('https://help.ahaslides.com/portal/ahaslides/en/kb/articles/one-time')
    },
    copyLink() {
      Utils.showToastSuccess(this.$i18nPresenter.t('Link copied!'))
    },
    fbShareLink() {
      const href = encodeURIComponent(this.referralLink)
      const redirectUri = encodeURIComponent('https://www.facebook.com')
      const appId = 938819863278189

      Utils.mixpanelTracking(
        'Presenter Referral Program',
        'Presenter Referral Program > Click Share Facebook ',
        'Share link referral to facebook',
      )

      const link = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=${href}&redirect_uri=${redirectUri}`
      window.open(link, '_blank')
    },
    twShareLink() {
      const href = encodeURIComponent(this.referralLink)
      const sharingText = 'Referral Program'
      const text = encodeURIComponent(`${sharingText.replace(' AhaSlides', ' @AhaSlides')} #ahaslides`)

      Utils.mixpanelTracking(
        'Presenter Referral Program',
        'Presenter Referral Program > Click Share Facebook ',
        'Share link referral to twitter',
      )

      const link = `https://twitter.com/intent/tweet?text=${text}&url=${href}`
      window.open(link, '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.gift {
  img {
    margin: 0 auto;
    margin-bottom: 32px;
  }
}
</style>
